/**
 * Determina si un color dado es oscuro o no.
 *
 * @param {string} color - El color a comprobar. Debe estar en formato hexadecimal.
 * @returns {boolean} - Devuelve verdadero si el color es oscuro, falso en caso contrario.
 */
export const isColorDark = (color) => {
  // Hexadecimal a RGB
  const rgb = parseInt(color?.slice(1), 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;

  // Luminosidad del color
  const luminosity = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminosity < 150;
};
